import { render, staticRenderFns } from "./ClientPortalUserStatus.vue?vue&type=template&id=1d2893f9&scoped=true&"
import script from "./ClientPortalUserStatus.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClientPortalUserStatus.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ClientPortalUserStatus.vue?vue&type=style&index=0&id=1d2893f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2893f9",
  null
  
)

export default component.exports